import auth from '@/app/middleware/auth';
import { getTwoGisApiKeyFromStorage } from '@/shared/api/two-gis/two-gis-key';

// @ts-ignore
export default async function twoGisAuth(context) {
  if (getTwoGisApiKeyFromStorage()) {
    return context.next();
  }

  return auth(context);
}
